export default __webpack_public_path__ + "static/media/lipiec.e67c6c9d.mp3";